<template>
    <el-dialog class="dialog" :visible.sync="visible" width='400px' top='10vh' custom-class="commentDialog" @close="dialogClose">
        <div class="scrollBox">
          <div v-for="item in items" :key="item._id" style="display: flex;flex-flow: row nowrap;justify-content: center;align-items: center;margin:8px 0;">
              <el-image v-if="item.isFolder" :src="require('@/assets/images/format/folder.png')" class="image"></el-image>
              <el-image v-else-if="imageTypes.includes(item.type.toLowerCase())" :src="item.thumbnail" class="image"></el-image>
              <el-image v-else-if="videoTypes.includes(item.type.toLowerCase())" :src="require('@/assets/images/format/video.png')" class="image"></el-image>
              <el-image v-else-if="item.type=='xlsx'" :src="require('@/assets/images/format/xlsx.png')" class="image"></el-image>
              <el-image v-else-if="item.type=='docx'" :src="require('@/assets/images/format/docx.png')" class="image"></el-image>
              <el-image v-else-if="item.type=='pdf'" :src="require('@/assets/images/format/pdf.png')" class="image"></el-image>
              <el-input type="textarea" v-model="item.name" style="width:75%;font-family:Arial, Helvetica, sans-serif" @change="rename($event,item)"></el-input>
          </div>
        </div>
    </el-dialog>
</template>

<script>
  import store from '@/store'
  import http from "@/http"
	export default {
		data() {
			return {
        imageTypes:['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp'],
        videoTypes:['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv'],
        docTypes:['doc', 'txt', 'docx', 'pages', 'epub', 'pdf', 'numbers', 'csv', 'xls', 'xlsx', 'keynote', 'ppt', 'pptx'],
        items:[],
        visible: false,
        user_id:store.state.user_id,
        routeName:null,
			}
		},
		methods: {
      async rename(e,item){
        await http.put(`${this.routeName}`, {name:e,id:item._id});
        this.callback()
      },
      dialogClose(){
        document.body.removeChild(this.$el);
        this.callback()
      }
		}
	}
</script>

<style lang="scss">
.scrollBox {
    max-height: 300px;
    width: 100%;
    overflow: auto;
}
.commentDialog{
  .el-dialog__header{
    display: none;
  }
}
.image {
    border-radius: 4px;
    width: 80px;
    height:75px;
    display: block;
    margin-right: 5px;
  }
</style>
<style scoped>
.dialog>>>.el-textarea__inner{
  height:85px;
}
.dialog>>>.el-scrollbar__wrap {
    overflow-x: hidden;
}
</style>
